/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archivebtnok2Inputs */



/**
* | output |
* | --- |
* | "OK" |
*
* @param {Archivebtnok2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const archivebtnok2 = /** @type {((inputs?: Archivebtnok2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archivebtnok2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("OK")
	if (locale === "es") return /** @type {LocalizedString} */ ("OK")
	return /** @type {LocalizedString} */ ("Ок")
});
export { archivebtnok2 as "archiveBtnOk" }